// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.provisioning

import org.multipaz.cbor.DataItem
import org.multipaz.provisioning.Display
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr

fun Display.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "BTB4HtQg6dUGXDrT5_PCunJRkwxFXae0Uh9Zxueca5U")
val Display_cborSchemaId = ByteString(5, 48, 120, 30, -44, 32, -23, -43, 6, 92, 58, -45, -25, -13, -62, -70, 114, 81, -109, 12, 69, 93, -89, -76, 82, 31, 89, -58, -25, -100, 107, -107)

fun Display.Companion.fromCbor(data: ByteArray): Display {
    return Display.fromDataItem(Cbor.decode(data))
}

val Display.Companion.cborSchemaId: ByteString
    get() = Display_cborSchemaId

fun Display.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("text", Tstr(this.text))
    val logo = this.logo
    if (logo != null) {
        builder.put("logo", Bstr(logo.toByteArray()))
    }
    val description = this.description
    if (description != null) {
        builder.put("description", Tstr(description))
    }
    val textColor = this.textColor
    if (textColor != null) {
        builder.put("textColor", Tstr(textColor))
    }
    val backgroundColor = this.backgroundColor
    if (backgroundColor != null) {
        builder.put("backgroundColor", Tstr(backgroundColor))
    }
    val backgroundImage = this.backgroundImage
    if (backgroundImage != null) {
        builder.put("backgroundImage", Bstr(backgroundImage.toByteArray()))
    }
    return builder.end().build()
}

fun Display.Companion.fromDataItem(dataItem: DataItem): Display {
    val text = dataItem["text"].asTstr
    val logo0 = if (dataItem.hasKey("logo")) {
        dataItem["logo"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val description0 = if (dataItem.hasKey("description")) {
        dataItem["description"].asTstr
    } else {
        null
    }
    val textColor0 = if (dataItem.hasKey("textColor")) {
        dataItem["textColor"].asTstr
    } else {
        null
    }
    val backgroundColor0 = if (dataItem.hasKey("backgroundColor")) {
        dataItem["backgroundColor"].asTstr
    } else {
        null
    }
    val backgroundImage0 = if (dataItem.hasKey("backgroundImage")) {
        dataItem["backgroundImage"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    return Display(
        text = text,
        logo = logo0,
        description = description0,
        textColor = textColor0,
        backgroundColor = backgroundColor0,
        backgroundImage = backgroundImage0,
    )
}
